export const ru = {
    age_0_17: 'от 0 до 17 лет',
    age_18_24: 'от 18 до 24 лет',
    age_25_34: 'от 25 до 35 лет',
    age_35_44: 'от 35 до 44 лет',
    age_45_54: 'от 45 до 54 лет',
    age_45_inf: '45+',
    age_55_inf: '55+',
    any: 'любой',
    'gender-and-age': 'пол: {gender}, возраст: {age}',
    gender_any: 'любой',
    gender_female: 'женский',
    gender_male: 'мужской',
    'on-condition': 'по условию «{condition}»'
};
